import { useMemo, useState } from 'react';

const defaultComparableValue = (row, property) => {
  const value = row?.[property];
  if (value === null || value === undefined) {
    return '';
  }
  if (typeof value === 'number') {
    return value;
  }
  if (typeof value === 'boolean') {
    return value ? 1 : 0;
  }
  if (value instanceof Date) {
    return value.getTime();
  }
  return value.toString().toLowerCase();
};

const sortComparator = (order, valueA, valueB) => {
  if (valueA < valueB) {
    return order === 'asc' ? -1 : 1;
  }
  if (valueA > valueB) {
    return order === 'asc' ? 1 : -1;
  }
  return 0;
};

export const useTableSort = (
  rows,
  {
    defaultOrder = 'asc',
    defaultOrderBy,
    getComparableValue = defaultComparableValue,
  }
) => {
  const [order, setOrder] = useState(defaultOrder);
  const [orderBy, setOrderBy] = useState(defaultOrderBy);

  const sortedRows = useMemo(() => {
    if (!orderBy) {
      return rows;
    }

    const stabilized = rows.map((row, index) => [row, index]);
    stabilized.sort((a, b) => {
      const aValue = getComparableValue(a[0], orderBy);
      const bValue = getComparableValue(b[0], orderBy);
      const orderResult = sortComparator(order, aValue, bValue);
      if (orderResult !== 0) {
        return orderResult;
      }
      return a[1] - b[1];
    });
    return stabilized.map((item) => item[0]);
  }, [rows, order, orderBy, getComparableValue]);

  const handleRequestSort = (property) => {
    if (!property) return;
    if (orderBy === property) {
      if (order === 'asc') {
        setOrder('desc');
      } else {
        // Troisième clic : retour à l'ordre naturel (pas de tri)
        setOrderBy(null);
        setOrder('asc');
      }
    } else {
      setOrder('asc');
      setOrderBy(property);
    }
  };

  return {
    order,
    orderBy,
    sortedRows,
    handleRequestSort,
    setOrder,
    setOrderBy,
  };
};

export default useTableSort;

